export class AppSettings {
    public title: string = "AskChevron";
    public version: string = "";
    public openAccess: boolean = false;
    public showNav: boolean = true;
    public showFooter: boolean = true;
    public supportLink: string = "";
    public user: any = null;
    public roles: any = null;
    // Allowed Azure AD group IDs for access control (loaded from config.json)
    public allowedGroups: string[] = [];
}

